export const formatTinForDisplay = (tin?: string): string => {
  if (!tin) {
    return "";
  }
  if (tin.length === 9) {
    return `${tin.slice(0, 2)}-${tin.slice(2)}`;
  }
  return tin;
};
